<template>
    <div v-bind:class="{ 'has-error': invalid, 'has-success': isDirty, 'i-am-sunny': disabled }">
        <label v-if="label" class="">{{ label }}</label>
        <div>
            <date-picker class="" @dp-change="update" v-model="date" :config="config" :disabled="disabled" v-bind:class="{ 'has-error': invalid, 'has-success': isDirty, 'i-am-sunny': disabled }"></date-picker>
        </div>
        <div class="help-block animated fadeInDown">
            <span v-if="invalid && (customErrorMsg || errorMsg)">
                {{customErrorMsg || errorMsg}}
            </span>
            <span v-else class='ghostly'>
                &nbsp;
            </span>
        </div>

    </div>
</template>

<script>
    import datePicker from 'vue-bootstrap-datetimepicker';
    import wcValidateMixin from '../../../mixins/wc-validated-mixin.js'

    // Import date picker css
    import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';


    export default {
        mixins: [ wcValidateMixin ],
        components: {
            datePicker
        },
        props: {
            label: { type: String, default: null },
            value: null,
            value0: null,
            disabled: { type: Boolean, default: false },
            neverDirty: { type: Boolean, default: false },
        },
        computed: {
            isDirty () {
                return this.neverDirty === false && this.value0 !== this.date;
            }
        },
        data () {
            return {
                date: new Date(),
                config: {
                    format: 'MM/DD/YYYY',
                    useCurrent: false,
                }
            };
        },
        methods: {
            update (e) {
                this.junk++;
                this.$emit('input', e.target.value);
            }
        },
        created () {
            this.date = this.value;
        }
    };
</script>



// WEBPACK FOOTER //
// wc-date.vue?5c3d22eb